// // frontend/src/components/AnnouncementBanner.js
// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { BASE_URL } from '../config';
// import { useSelector } from 'react-redux';

// const AnnouncementBanner = () => {
//   const [announcement, setAnnouncement] = useState(null);
//   const [dismissed, setDismissed] = useState(false);
//   const { authUser } = useSelector(store => store.user);

//   useEffect(() => {
//     const fetchAnnouncement = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}/api/v1/announcement/announcements`);
//         if (response.data?.status === 'active') {
//           setAnnouncement(response.data);
//         }
//       } catch (error) {
//         console.error('Error fetching announcement:', error);
//       }
//     };
    
//     // Check local storage for dismissal
//     const isDismissed = localStorage.getItem('announcementDismissed');
//     if (!isDismissed) {
//       fetchAnnouncement();
//     }
//   }, []);

//   const handleDismiss = () => {
//     setDismissed(true);
//     localStorage.setItem('announcementDismissed', 'true');
//   };

//   if (!announcement || dismissed || authUser?.isRole === 1) return null;

//   return (
//     <div className="bg-yellow-100 p-4 text-center relative">
//       <div className="max-w-4xl mx-auto">
//         {announcement.link ? (
//           <a
//             href={announcement.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-blue-600 hover:underline"
//           >
//             <strong>{announcement.title}:</strong> {announcement.content}
//           </a>
//         ) : (
//           <p>
//             <strong>{announcement.title}:</strong> {announcement.content}
//           </p>
//         )}
//       </div>
//       <button
//         onClick={handleDismiss}
//         className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
//       >
//         �
//       </button>
//     </div>
//   );
// };


// export default AnnouncementBanner;



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { BASE_URL } from '../config';
// import { useSelector } from 'react-redux';

// const AnnouncementBanner = () => {
//   const [announcement, setAnnouncement] = useState(null);
//   const [dismissed, setDismissed] = useState(false);
//   const { authUser } = useSelector(store => store.user);

//   useEffect(() => {
//     const fetchAnnouncement = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}/api/v1/announcement/announcements`);
//         if (response.data) {
//           const { _id, updatedAt } = response.data;
//           const dismissalKey = `announcementDismissed_${_id}_${updatedAt}`;
//           const isDismissed = localStorage.getItem(dismissalKey);
//           if (!isDismissed) {
//             setAnnouncement(response.data);
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching announcement:', error);
//       }
//     };

//     // Fetch immediately and then every minute
//     fetchAnnouncement();
//     const interval = setInterval(fetchAnnouncement, 60000); // Adjust interval as needed

//     return () => clearInterval(interval);
//   }, []);

//   const handleDismiss = () => {
//     if (!announcement) return;
//     setDismissed(true);
//     const dismissalKey = `announcementDismissed_${announcement._id}_${announcement.updatedAt}`;
//     localStorage.setItem(dismissalKey, 'true');
//   };

//   if (!announcement || dismissed || authUser?.isRole === 1) return null;

//   return (
//     <div className="bg-yellow-100 p-4 text-center relative">
//       <div className="max-w-4xl mx-auto">
//         {announcement.link ? (
//           <a
//             href={announcement.link}
//             target="_blank"
//             rel="noopener noreferrer"
//             className="text-blue-600 hover:underline"
//           >
//             <strong>{announcement.title}:</strong> {announcement.content}
//           </a>
//         ) : (
//           <p>
//             <strong>{announcement.title}:</strong> {announcement.content}
//           </p>
//         )}
//       </div>
//       <button
//         onClick={handleDismiss}
//         className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
//       >
//         ×
//       </button>
//     </div>
//   );
// };

// export default AnnouncementBanner;


// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { BASE_URL } from '../config';
// import { useSelector } from 'react-redux';

// const AnnouncementBanner = () => {
//   const [announcement, setAnnouncement] = useState(null);
//   const [dismissed, setDismissed] = useState(false);
//   const [showFull, setShowFull] = useState(false); // For mobile expandable text
//   const { authUser } = useSelector(store => store.user);

//   useEffect(() => {
//     const fetchAnnouncement = async () => {
//       try {
//         const response = await axios.get(`${BASE_URL}/api/v1/announcement/announcements`);
//         if (response.data) {
//           const { _id, updatedAt } = response.data;
//           const dismissalKey = `announcementDismissed_${_id}_${updatedAt}`;
//           const isDismissed = localStorage.getItem(dismissalKey);
//           if (!isDismissed) {
//             setAnnouncement(response.data);
//           }
//         }
//       } catch (error) {
//         console.error('Error fetching announcement:', error);
//       }
//     };

//     fetchAnnouncement();
//     const interval = setInterval(fetchAnnouncement, 60000);
//     return () => clearInterval(interval);
//   }, []);

//   const handleDismiss = () => {
//     if (!announcement) return;
//     setDismissed(true);
//     const dismissalKey = `announcementDismissed_${announcement._id}_${announcement.updatedAt}`;
//     localStorage.setItem(dismissalKey, 'true');
//   };

//   if (!announcement || dismissed || authUser?.isRole === 1) return null;

//   return (
//     <div className="bg-yellow-100 p-3 relative border-b border-yellow-300">
//       <div className="max-w-4xl mx-auto flex items-center justify-between gap-2 flex-wrap sm:flex-nowrap">
//         <div
//           className={`text-sm sm:text-base ${!showFull ? 'truncate' : ''} w-full sm:w-auto cursor-pointer`}
//           onClick={() => setShowFull(prev => !prev)}
//           title={!showFull ? 'Tap to view full message' : ''}
//         >
//           {announcement.link ? (
//             <a
//               href={announcement.link}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="text-blue-600 hover:underline"
//             >
//               <strong>{announcement.title}:</strong> {announcement.content}
//             </a>
//           ) : (
//             <span>
//               <strong>{announcement.title}:</strong> {announcement.content}
//             </span>
//           )}
//         </div>
//         <button
//           onClick={handleDismiss}
//           className="text-lg text-gray-500 hover:text-gray-700 sm:ml-4 self-start sm:self-auto absolute right-3 top-2 sm:static"
//           aria-label="Dismiss"
//         >
//           ×
//         </button>
//       </div>
//     </div>
//   );
// };

// export default AnnouncementBanner;



import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from '../config';
import { useSelector } from 'react-redux';

const AnnouncementBanner = () => {
  const [announcement, setAnnouncement] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const { authUser } = useSelector(store => store.user);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api/v1/announcement/announcements`);
        if (response.data) {
          const { _id, updatedAt } = response.data;
          const dismissalKey = `announcementDismissed_${_id}_${updatedAt}`;
          const isDismissed = localStorage.getItem(dismissalKey);
          if (!isDismissed) {
            setAnnouncement(response.data);
          }
        }
      } catch (error) {
        console.error('Error fetching announcement:', error);
      }
    };

    fetchAnnouncement();
    const interval = setInterval(fetchAnnouncement, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleDismiss = () => {
    if (!announcement) return;
    setDismissed(true);
    const dismissalKey = `announcementDismissed_${announcement._id}_${announcement.updatedAt}`;
    localStorage.setItem(dismissalKey, 'true');
  };

  if (!announcement || dismissed || authUser?.isRole === 1) return null;

  return (
    <div className="bg-yellow-100 p-3 relative border-b border-yellow-300">
      <div className="max-w-4xl mx-auto flex items-center justify-between gap-2 flex-wrap sm:flex-nowrap">
        <div className="text-sm sm:text-base w-full sm:w-auto">
          {announcement.link ? (
            <a
              href={announcement.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline"
            >
              <strong>{announcement.title}:</strong> {announcement.content}
            </a>
          ) : (
            <span>
              <strong>{announcement.title}:</strong> {announcement.content}
            </span>
          )}
        </div>
        <button
          onClick={handleDismiss}
          className="text-lg text-gray-500 hover:text-gray-700 sm:ml-4 self-start sm:self-auto absolute right-3 top-2 sm:static"
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
